import api from "@/api/index";
import esupplyvetApi from "@/api/esupplyvet";

class FormContactService {
  /**
   * Sends form contact data to the server.
   * @param {Object} formData - The form data to be sent.
   * @param {boolean} isVeterinaire - Flag to determine which API to use based on user role.
   * @returns {Promise} - The promise resolving to the server response.
   */
  static sendFormContact(formData, isVeterinaire) {
    const selectedApi = isVeterinaire ? api : esupplyvetApi;
    return selectedApi.post("/form-contacts", formData);
  }
}

export default FormContactService;
